<template>
  <div>
    <subscribe-notifier></subscribe-notifier>
    <nav
      :style="
        disabled ? 'opacity:.6; user-select:none; pointer-events:none' : ''
      "
      class="navbar navbar-dashboard navbar-expand-lg navbar-light bg-light"
    >
      <div class="container-fluid pl-4 pr-4">
        <a class="navbar-brand" href="#">
          <img src="@/assets/img/leaf.svg" class="logo-main" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-5 projects-link">
            <div class="pl-4">
              <li class="nav-item">
                <router-link
                  class="nav-link p-15 no-underline"
                  :to="{ name: 'dashboard' }"
                >
                  <span class="pr-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill="#72809D"
                        d="M8.4 2c-.14 0-.273.055-.373.152L2.21 6.91l-.02.016-.02.017c-.107.101-.169.243-.169.39 0 .295.239.534.533.534h.534v5.866c0 .59.477 1.067 1.066 1.067h8.534c.589 0 1.066-.477 1.066-1.067V7.867h.534c.294 0 .533-.24.533-.534 0-.148-.061-.29-.17-.39l-.008-.007-.037-.03-.852-.697V4.133c0-.294-.239-.533-.533-.533h-.533c-.295 0-.534.239-.534.533v.768L8.761 2.143C8.663 2.05 8.534 2 8.4 2zM10 8.933h2.133V13.2H10V8.933z"
                      ></path>
                    </svg>
                  </span>
                  Home
                  <span class="sr-only">(current)</span>
                </router-link>
              </li>

              <li class="nav-item">
                <router-link
                  class="nav-link p-15 no-underline"
                  :id="
                    checkSubLink('projects-index') ? 'router-link-exact-active' : ''
                  "
                  :to="{ name: 'projects-index' }"
                >
                  <span class="pr-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 16 16"
                      fill="#72809D"
                    >
                      <path
                        d="M3.067 2C2.477 2 2 2.477 2 3.067v1.066h12.8V3.067c0-.59-.477-1.067-1.067-1.067H3.067zm-.534 3.2v7.467c0 .589.478 1.066 1.067 1.066h9.6c.59 0 1.067-.477 1.067-1.066V5.2H2.533zM6.8 6.8H10c.294 0 .533.239.533.533 0 .295-.239.534-.533.534H6.8c-.294 0-.533-.24-.533-.534 0-.294.239-.533.533-.533z"
                      ></path>
                    </svg>
                  </span>
                  Projects
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :id="
                    checkSubLink('opportunities')
                      ? 'router-link-exact-active'
                      : ''
                  "
                  class="nav-link p-15 no-underline"
                  :to="{ name: 'opportunities-index' }"
                >
                  <i class="zmdi zmdi-map pr-1" style="font-size: 16px"></i>
                  Opportunities
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :id="checkSubLink('tasks-index') ? 'router-link-exact-active' : ''"
                  class="nav-link p-15 no-underline"
                  :to="{ name: 'tasks-index' }"
                >
                  <span class="pr-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 16 16"
                      fill="#72809D"
                    >
                      <path
                        d="M4.6 1C3.716 1 3 1.716 3 2.6v9.6c0 .142.057.278.157.378.188.674.713 1.222 1.443 1.222h.533v-1.067H4.6c-.301 0-.533-.232-.533-.533 0-.301.232-.533.533-.533h8c.59 0 1.067-.478 1.067-1.067V2.067c0-.59-.478-1.067-1.067-1.067h-8zm.533 1.6h.534c.294 0 .533.239.533.533v.534c0 .294-.239.533-.533.533h-.534c-.294 0-.533-.239-.533-.533v-.534c0-.294.239-.533.533-.533zm0 2.667h.534c.294 0 .533.239.533.533v.533c0 .295-.239.534-.533.534h-.534c-.294 0-.533-.24-.533-.534V5.8c0-.294.239-.533.533-.533zm0 2.666h.534c.294 0 .533.24.533.534V9c0 .294-.239.533-.533.533h-.534C4.84 9.533 4.6 9.294 4.6 9v-.533c0-.295.239-.534.533-.534zm1.067 4.8V15.4l1.6-1.067L9.4 15.4v-2.667H6.2zm4.267 0V13.8h2.666c.295 0 .534-.239.534-.533 0-.295-.24-.534-.534-.534h-2.666z"
                      ></path>
                    </svg>
                  </span>
                  Tasks
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :id="
                    checkSubLink('customers') ? 'router-link-exact-active' : ''
                  "
                  class="nav-link p-15 no-underline"
                  :to="{ name: 'customers-index' }"
                >
                  <span class="pr-1">
                    <svg
                      width="15px"
                      height="15px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <!-- Generator: sketchtool 61 (101010) - https://sketch.com -->
                      <title>3431479B-9F9D-459C-AFFC-95A7928A33C4</title>
                      <desc>Created with sketchtool.</desc>
                      <g
                        id="Work-Page"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="3.-Projects-Landing"
                          transform="translate(-541.000000, -18.000000)"
                          fill="#72809D"
                          fill-rule="nonzero"
                        >
                          <g id="Header">
                            <g
                              id="Menu-Item/Unselected"
                              transform="translate(529.000000, 0.000000)"
                            >
                              <g
                                id="3.-Icons/Leaf-3/Contacts"
                                transform="translate(12.000000, 18.000000)"
                              >
                                <path
                                  d="M5.06666667,2 C3.2064,2 2.13333333,3.4512 2.13333333,5.2 C2.13333333,5.7888 2.41458336,6.38125013 2.41458336,6.38125013 C2.30151669,6.4463168 2.11556667,6.65285813 2.1625,7.01979147 C2.24996667,7.70405813 2.54661664,7.87726667 2.73541664,7.89166667 C2.80741664,8.5306 3.49333333,9.34773333 3.73333333,9.46666667 L3.73333333,10.5333333 C3.2,12.1333333 0,11.0666667 0,14.8 L4.8,14.8 C4.8,12.5728 5.7939168,11.5942336 6.76458347,11.0625003 C6.6035168,10.9233003 6.47413333,10.7557333 6.4,10.5333333 L6.4,9.46666667 C6.60426667,9.36586667 7.12713333,8.76078347 7.325,8.18958347 C7.15753333,7.92398347 7.02629973,7.58883307 6.97083307,7.1541664 C6.9249664,6.79310027 6.97918347,6.47954987 7.08958347,6.21874987 C7.0069168,5.9312832 6.93333333,5.5712 6.93333333,5.2 C6.93333333,4.4608 7.08630827,3.78356667 7.35937493,3.19583333 C7.11297493,2.94836667 6.79626667,2.8 6.4,2.8 C6.4,2.8 6.20053333,2 5.06666667,2 Z M10.9333333,2.00104151 C9.07306667,2.00050832 8,3.4512 8,5.2 C8,5.7888 8.28125013,6.38125013 8.28125013,6.38125013 C8.16818347,6.4463168 7.9822336,6.65285813 8.02916693,7.01979147 C8.11663307,7.70405813 8.4132832,7.87726667 8.6020832,7.89166667 C8.6740832,8.5306 9.36,9.34773333 9.6,9.46666667 L9.6,10.5333333 C9.06666667,12.1333333 5.86666667,11.0666667 5.86666667,14.8 L16,14.8 C16,11.0666667 12.8,12.1333333 12.2666667,10.5333333 L12.2666667,9.46666667 C12.5066667,9.34773333 13.1925835,8.53110827 13.2645835,7.89270827 C13.4533835,7.87830827 13.7500331,7.70405813 13.8374997,7.01979147 C13.8844336,6.6523248 13.6984832,6.4463168 13.5854165,6.38125013 C13.5854165,6.38125013 13.8666667,5.84690827 13.8666667,5.20104165 C13.8666667,3.90610832 13.3584,2.80104165 12.2666667,2.80104165 C12.2666667,2.80104165 12.0672,2.00104151 10.9333333,2.00104151 Z"
                                  id="Shape"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                  Customers
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :id="
                    checkSubLink('invoices') ? 'router-link-exact-active' : ''
                  "
                  class="nav-link p-15 no-underline"
                  :to="{ name: 'invoices' }"
                >
                  <span class="pr-1">
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <!-- Generator: sketchtool 61 (101010) - https://sketch.com -->
                      <title>842F9367-CFD9-4F1B-8CA3-F4DDF4C9C499</title>
                      <desc>Created with sketchtool.</desc>
                      <g
                        id="Work-Page"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="3.-Projects-Landing"
                          transform="translate(-661.000000, -18.000000)"
                          fill="#72809D"
                          fill-rule="nonzero"
                        >
                          <g id="Header">
                            <g
                              id="Menu-Item/Unselected"
                              transform="translate(649.000000, 0.000000)"
                            >
                              <g
                                id="3.-Icons/Leaf-3/Invoice"
                                transform="translate(12.000000, 18.000000)"
                              >
                                <path
                                  d="M12.6,2.49487181 L11.5333333,2 L10.4666667,2.49487181 L9.4,2 L8.33333333,2.49487181 L7.26666667,2 L6.2,2.49487181 L5.13333333,2 L4.06666667,2.49487181 L3,2 L3,13.8769234 C3,14.4237567 3.47733333,14.866667 4.06666667,14.866667 L12.6,14.866667 C13.1893333,14.866667 13.6666667,14.4237567 13.6666667,13.8769234 L13.6666667,2 L12.6,2.49487181 Z M8.86666667,12.392308 L5.66666667,12.392308 C5.37226667,12.392308 5.13333333,12.1706054 5.13333333,11.8974362 C5.13333333,11.6242669 5.37226667,11.4025643 5.66666667,11.4025643 L8.86666667,11.4025643 C9.16106667,11.4025643 9.4,11.6242669 9.4,11.8974362 C9.4,12.1706054 9.16106667,12.392308 8.86666667,12.392308 Z M5.13333333,9.91794892 C5.13333333,9.64477969 5.37226667,9.42307712 5.66666667,9.42307712 L7.8,9.42307712 C8.0944,9.42307712 8.33333333,9.64477969 8.33333333,9.91794892 C8.33333333,10.1911182 8.0944,10.4128207 7.8,10.4128207 L5.66666667,10.4128207 C5.37226667,10.4128207 5.13333333,10.1911182 5.13333333,9.91794892 Z M8.86666667,8.4333335 L5.66666667,8.4333335 C5.37226667,8.4333335 5.13333333,8.21163093 5.13333333,7.93846169 C5.13333333,7.66529245 5.37226667,7.44358988 5.66666667,7.44358988 L8.86666667,7.44358988 C9.16106667,7.44358988 9.4,7.66529245 9.4,7.93846169 C9.4,8.21163093 9.16106667,8.4333335 8.86666667,8.4333335 Z M11,12.392308 C10.7056,12.392308 10.4666667,12.1706054 10.4666667,11.8974362 C10.4666667,11.6242669 10.7056,11.4025643 11,11.4025643 C11.2944,11.4025643 11.5333333,11.6242669 11.5333333,11.8974362 C11.5333333,12.1706054 11.2944,12.392308 11,12.392308 Z M11,10.4128207 C10.7056,10.4128207 10.4666667,10.1911182 10.4666667,9.91794892 C10.4666667,9.64477969 10.7056,9.42307712 11,9.42307712 C11.2944,9.42307712 11.5333333,9.64477969 11.5333333,9.91794892 C11.5333333,10.1911182 11.2944,10.4128207 11,10.4128207 Z M11,8.4333335 C10.7056,8.4333335 10.4666667,8.21163093 10.4666667,7.93846169 C10.4666667,7.66529245 10.7056,7.44358988 11,7.44358988 C11.2944,7.44358988 11.5333333,7.66529245 11.5333333,7.93846169 C11.5333333,8.21163093 11.2944,8.4333335 11,8.4333335 Z M11,5.46410265 L5.66666667,5.46410265 C5.37226667,5.46410265 5.13333333,5.24240008 5.13333333,4.96923085 C5.13333333,4.69606161 5.37226667,4.47435904 5.66666667,4.47435904 L11,4.47435904 C11.2944,4.47435904 11.5333333,4.69606161 11.5333333,4.96923085 C11.5333333,5.24240008 11.2944,5.46410265 11,5.46410265 Z"
                                  id="Shape"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                  Invoices
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  v-if="optional($auth.user(), 'org_role.role_id') == 1"
                  :id="
                    checkSubLink('payments') ? 'router-link-exact-active' : ''
                  "
                  class="nav-link p-15 no-underline"
                  :to="{ name: 'payments' }"
                >
                  <i
                    class="zmdi zmdi-balance-wallet pr-1"
                    style="font-size: 16px"
                  ></i>
                  Payroll
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  v-if="optional($auth.user(), 'org_role.role_id') == 1"
                  :id="checkSubLink('users') ? 'router-link-exact-active' : ''"
                  class="nav-link p-15 no-underline"
                  :to="{ name: 'users-index' }"
                >
                  <span class="pr-1">
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g
                        id="Work-Page"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="3.-Projects-Landing"
                          transform="translate(-880.000000, -18.000000)"
                          fill="#72809D"
                          fill-rule="nonzero"
                        >
                          <g id="Header">
                            <g
                              id="Menu-Item/Unselected"
                              transform="translate(868.000000, 0.000000)"
                            >
                              <g
                                id="3.-Icons/Leaf-3/Employees"
                                transform="translate(12.000000, 18.000000)"
                              >
                                <path
                                  d="M12.6666667,1 L2,1 L2,14.8666667 L12.6666667,14.8666667 C13.256,14.8666667 13.7333333,14.3893333 13.7333333,13.8 L13.7333333,2.06666667 C13.7333333,1.47733333 13.256,1 12.6666667,1 Z M4.66666667,11.1333333 C4.66666667,9.11093333 6.8,9.68906667 7.06666667,8.8224 L7.06666667,8.2448 C6.94666667,8.18026667 6.60373333,7.7376 6.56746667,7.392 C6.47306667,7.384 6.3248,7.29013333 6.28106667,6.91946667 C6.2576,6.72053333 6.35093333,6.60853333 6.40746667,6.57333333 C6.40746667,6.57333333 6.26666667,6.25226667 6.26666667,5.93386667 C6.26666667,4.98613333 6.73546667,4.2 7.86666667,4.2 C8.47733333,4.2 8.66666667,4.63306667 8.66666667,4.63306667 C9.21226667,4.63306667 9.46666667,5.23146667 9.46666667,5.93333333 C9.46666667,6.2832 9.32586667,6.5728 9.32586667,6.5728 C9.3824,6.608 9.47573333,6.72 9.45226667,6.91893333 C9.40853333,7.2896 9.26026667,7.38346667 9.16586667,7.39146667 C9.1296,7.73706667 8.78666667,8.17973333 8.66666667,8.24426667 L8.66666667,8.82186667 C8.93333333,9.68906667 11.0666667,9.11093333 11.0666667,11.1333333 L4.66666667,11.1333333 Z"
                                  id="Shape"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                  Users
                </router-link>
              </li>
            </div>
          </ul>
          <div class="right-nav">
            <div class="row float-right">
              <!-- <div class="col-sm-12 col-lg-8">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">
                      <i class="zmdi zmdi-search"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control search-input"
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                  >
                </div>
              </div> -->
              <!-- <div class="col-sm-12 col-lg-2 pt-1">
                <span>
                  <svg
                    width="16px"
                    height="18px"
                    viewBox="0 0 16 18"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Work-Page"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="3.-Projects-Landing"
                        transform="translate(-1303.000000, -18.000000)"
                        fill="#72809D"
                        fill-rule="nonzero"
                      >
                        <g id="Header">
                          <g id="icons-doorbell" transform="translate(1303.000000, 18.000000)">
                            <path
                              d="M7.92959984,0 C7.13753586,0 6.49599987,0.641535987 6.49599987,1.43359997 L6.49599987,1.6212 C4.02429346,2.25885029 2.19519996,4.49723529 2.19519996,7.16799986 L2.19519996,8.88439964 C2.19519996,10.0241116 1.96113114,11.1440894 1.52459995,12.1855998 L14.3345998,12.1855998 C13.8980686,11.1448062 13.6639997,10.0241116 13.6639997,8.88439964 L13.6639997,7.16799986 C13.6639997,4.49723529 11.8349061,2.25885029 9.36319981,1.6212 L9.36319981,1.43359997 C9.36319981,0.641535987 8.72166383,0 7.92959984,0 Z M0.761599985,13.6191997 C0.503096165,13.6155438 0.262648873,13.7513599 0.132330079,13.9746414 C0.00201128456,14.1979228 0.00201128456,14.4740766 0.132330079,14.697358 C0.262648873,14.9206395 0.503096165,15.0564556 0.761599985,15.0527997 L5.9051997,15.0527997 C5.82277837,15.2828386 5.78016831,15.5252429 5.77919989,15.7695997 C5.77919989,16.9572328 6.74196674,17.9199996 7.92959984,17.9199996 C9.11723294,17.9199996 10.0799998,16.9572328 10.0799998,15.7695997 C10.0794807,15.5253236 10.0373445,15.2829217 9.95539989,15.0527997 L15.0975997,15.0527997 C15.3561035,15.0564556 15.5965508,14.9206395 15.7268696,14.697358 C15.8571884,14.4740766 15.8571884,14.1979228 15.7268696,13.9746414 C15.5965508,13.7513599 15.3561035,13.6155438 15.0975997,13.6191997 L7.92959984,13.6191997 L0.761599985,13.6191997 Z"
                              id="Shape"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </span>
                <sup>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    viewBox="0 0 16 16"
                  >
                    <rect
                      id="Rectangle_1"
                      data-name="Rectangle 1"
                      width="10"
                      height="10"
                      rx="8"
                      fill="#912121"
                    ></rect>
                  </svg>
                </sup>
              </div>-->
              <div
                class="col-sm-12 col-lg-2 pt-1"
                style="width: auto; padding-right: 20px; cursor: pointer"
                @click="toggleDropDown()"
              >
                <b-dropdown id="dropdown-profile" ref="dropmenu" no-caret>
                  <template
                    class="btn-primary btn-dropdown"
                    v-slot:button-content
                  >
                    <i class="zmdi zmdi-account" style="font-size: 30px"></i>
                  </template>
                  <router-link :to="{ name: 'profile' }" class="no-underline">
                      <b-dropdown-item-button class="header" v-if="organization">
                        <span style="display: flex;flex-direction: column;align-items: flex-end;">
                          <small style="color:green" class="text-opacity-pale">Current Org.</small>
                          <h6 class="text-bold h7">{{ organization.name }}</h6>
                        </span>
                      </b-dropdown-item-button>
                  </router-link>
                  <router-link :to="{ name: 'profile' }" class="no-underline">
                    <b-dropdown-item-button class="header">
                      <span class="pr-2" style="color: #0a5685">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 30 30"
                          fill="#0a5685"
                        >
                          <path
                            d="M12 2c2.757 0 5 2.243 5 5.001 0 2.756-2.243 5-5 5s-5-2.244-5-5c0-2.758 2.243-5.001 5-5.001zm0-2c-3.866 0-7 3.134-7 7.001 0 3.865 3.134 7 7 7s7-3.135 7-7c0-3.867-3.134-7.001-7-7.001zm6.369 13.353c-.497.498-1.057.931-1.658 1.302 2.872 1.874 4.378 5.083 4.972 7.346h-19.387c.572-2.29 2.058-5.503 4.973-7.358-.603-.374-1.162-.811-1.658-1.312-4.258 3.072-5.611 8.506-5.611 10.669h24c0-2.142-1.44-7.557-5.631-10.647z"
                          ></path>
                        </svg>
                      </span>
                      <span class="text-medium" style="color: #0a5685"
                        >Profile</span
                      >
                    </b-dropdown-item-button>
                  </router-link>
                  <router-link
                    v-if="optional($auth.user(), 'org_role.role_id') == 1"
                    :to="{ name: `settings` }"
                    class="no-underline"
                  >
                    <b-dropdown-item-button class="header">
                      <span class="pr-2" style="color: #0a5685">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 30 30"
                          fill="#0a5685"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M24 14.187v-4.374c-2.148-.766-2.726-.802-3.027-1.529-.303-.729.083-1.169 1.059-3.223l-3.093-3.093c-2.026.963-2.488 1.364-3.224 1.059-.727-.302-.768-.889-1.527-3.027h-4.375c-.764 2.144-.8 2.725-1.529 3.027-.752.313-1.203-.1-3.223-1.059l-3.093 3.093c.977 2.055 1.362 2.493 1.059 3.224-.302.727-.881.764-3.027 1.528v4.375c2.139.76 2.725.8 3.027 1.528.304.734-.081 1.167-1.059 3.223l3.093 3.093c1.999-.95 2.47-1.373 3.223-1.059.728.302.764.88 1.529 3.027h4.374c.758-2.131.799-2.723 1.537-3.031.745-.308 1.186.099 3.215 1.062l3.093-3.093c-.975-2.05-1.362-2.492-1.059-3.223.3-.726.88-.763 3.027-1.528zm-4.875.764c-.577 1.394-.068 2.458.488 3.578l-1.084 1.084c-1.093-.543-2.161-1.076-3.573-.49-1.396.581-1.79 1.693-2.188 2.877h-1.534c-.398-1.185-.791-2.297-2.183-2.875-1.419-.588-2.507-.045-3.579.488l-1.083-1.084c.557-1.118 1.066-2.18.487-3.58-.579-1.391-1.691-1.784-2.876-2.182v-1.533c1.185-.398 2.297-.791 2.875-2.184.578-1.394.068-2.459-.488-3.579l1.084-1.084c1.082.538 2.162 1.077 3.58.488 1.392-.577 1.785-1.69 2.183-2.875h1.534c.398 1.185.792 2.297 2.184 2.875 1.419.588 2.506.045 3.579-.488l1.084 1.084c-.556 1.121-1.065 2.187-.488 3.58.577 1.391 1.689 1.784 2.875 2.183v1.534c-1.188.398-2.302.791-2.877 2.183zm-7.125-5.951c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0-2c-2.762 0-5 2.238-5 5s2.238 5 5 5 5-2.238 5-5-2.238-5-5-5z"
                          ></path>
                        </svg>
                      </span>
                      <span class="text-medium" style="color: #0a5685"
                        >Settings</span
                      >
                    </b-dropdown-item-button>
                  </router-link>
                  <router-link
                    v-if="optional($auth.user(), 'org_role.role_id') == 1"
                    :to="{ name: `users-index` }"
                    class="no-underline"
                  >
                    <b-dropdown-item-button class="header">
                      <span class="pr-2" style="color: #0a5685">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 30 30"
                          fill="#0a5685"
                        >
                          <path
                            d="M9 12.242v7.894l-4.291.864-.709-3.827 4.005-5.909c.331.382.352.46.995.978zm2 1.176v8.015l2.732 2.567 3.268-2.567-1.052-1.109 1.052-1.108-1.052-1.108 1.052-1.108v-3.583c-.941.381-1.955.583-3.001.583-1.045 0-2.059-.202-2.999-.582zm7.242-11.661c-2.131-2.131-5.424-2.25-7.687-.651-1.174.821-1.96 1.94-2.335 3.378-1.664-.087-2.72-.905-2.72-1.484 0-.6 1.128-1.46 2.898-1.494.42-.524.67-.822 1.42-1.36-.42-.086-.856-.146-1.318-.146-2.485 0-4.5 1.343-4.5 3 0 1.936 2.526 3 4.5 3 2.818 0 5.337-1.892 4.252-3.967.567-.912 1.682-.902 2.309-.275.975.975.24 2.625-1.146 2.544-.862 2.006-3.376 3-5.794 2.879.225 1.122.768 2.192 1.638 3.062 2.342 2.344 6.141 2.343 8.484 0 1.17-1.172 1.757-2.708 1.757-4.244 0-1.535-.586-3.07-1.758-4.242z"
                          ></path>
                        </svg>
                      </span>
                      <span class="text-medium" style="color: #0a5685"
                        >Manage Users</span
                      >
                    </b-dropdown-item-button>
                  </router-link>
                  <router-link
                    v-if="optional($auth.user(), 'org_role.role_id') == 1"
                    :to="{ name: `reporting-index` }"
                    class="no-underline"
                  >
                    <b-dropdown-item-button class="header">
                      <span class="pr-2" style="color: #0a5685">
                        <svg
                          fill="#0a5685"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 30 30"
                        >
                          <path
                            d="M5 20v2h-2v-2h2zm2-2h-6v6h6v-6zm6-1v5h-2v-5h2zm2-2h-6v9h6v-9zm6-2v9h-2v-9h2zm2-2h-6v13h6v-13zm0-11l-6 1.221 1.716 1.708-6.85 6.733-3.001-3.002-7.841 7.797 1.41 1.418 6.427-6.39 2.991 2.993 8.28-8.137 1.667 1.66 1.201-6.001z"
                          ></path>
                        </svg>
                      </span>
                      <span class="text-medium" style="color: #0a5685"
                        >Reporting</span
                      >
                    </b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{ path: `/users/${this.$auth.user().id}` }"
                    class="no-underline"
                  >
                    <b-dropdown-item-button class="header">
                      <span class="pr-2" style="color: #0a5685">
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 30 30"
                          fill="#0a5685"
                          xmlns="http://www.w3.org/2000/svg"
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                        >
                          <path
                            d="M22 22h-20c-1.104 0-2-.896-2-2v-12c0-1.104.896-2 2-2h1.626l.078.283c.194.631.518 1.221.95 1.717h-2.154c-.276 0-.5.224-.5.5v5.5h20v-5.5c0-.276-.224-.5-.5-.5h-2.154c.497-.569.853-1.264 1.029-2h1.625c1.104 0 2 .896 2 2v12c0 1.104-.896 2-2 2zm-20-5v2.5c0 .276.224.5.5.5h19c.276 0 .5-.224.5-.5v-2.5h-20zm8.911-5h-2.911c.584-1.357 1.295-2.832 2-4-.647-.001-1.572.007-2 0-2.101-.035-2.987-1.806-3-3-.016-1.534 1.205-3.007 3-3 1.499.006 2.814.872 4 2.313 1.186-1.441 2.501-2.307 4-2.313 1.796-.007 3.016 1.466 3 3-.013 1.194-.899 2.965-3 3-.428.007-1.353-.001-2 0 .739 1.198 1.491 2.772 2 4h-2.911c-.241-1.238-.7-2.652-1.089-3.384-.388.732-.902 2.393-1.089 3.384zm-2.553-7.998c-1.131 0-1.507 1.918.12 1.998.237.012 2.235 0 2.235 0-1.037-1.44-1.52-1.998-2.355-1.998zm7.271 0c1.131 0 1.507 1.918-.12 1.998-.237.012-2.222 0-2.222 0 1.037-1.44 1.507-1.998 2.342-1.998z"
                          ></path>
                        </svg>
                      </span>
                      <span class="text-medium" style="color: #0a5685"
                        >Invite Friends</span
                      >
                    </b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{ name: 'subcriptions-active' }"
                    v-if="optional($auth.user(), 'org_role.role_id') == 1"
                    class="no-underline"
                  >
                    <b-dropdown-item-button class="header">
                      <span class="pr-2" style="color: #0a5685">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 30 30"
                          fill="#0a5685"
                        >
                          <path
                            d="M23.334 11.96c-.713-.726-.872-1.829-.393-2.727.342-.64.366-1.401.064-2.062-.301-.66-.893-1.142-1.601-1.302-.991-.225-1.722-1.067-1.803-2.081-.059-.723-.451-1.378-1.062-1.77-.609-.393-1.367-.478-2.05-.229-.956.347-2.026.032-2.642-.776-.44-.576-1.124-.915-1.85-.915-.725 0-1.409.339-1.849.915-.613.809-1.683 1.124-2.639.777-.682-.248-1.44-.163-2.05.229-.61.392-1.003 1.047-1.061 1.77-.082 1.014-.812 1.857-1.803 2.081-.708.16-1.3.642-1.601 1.302s-.277 1.422.065 2.061c.479.897.32 2.001-.392 2.727-.509.517-.747 1.242-.644 1.96s.536 1.347 1.17 1.7c.888.495 1.352 1.51 1.144 2.505-.147.71.044 1.448.519 1.996.476.549 1.18.844 1.902.798 1.016-.063 1.953.54 2.317 1.489.259.678.82 1.195 1.517 1.399.695.204 1.447.072 2.031-.357.819-.603 1.936-.603 2.754 0 .584.43 1.336.562 2.031.357.697-.204 1.258-.722 1.518-1.399.363-.949 1.301-1.553 2.316-1.489.724.046 1.427-.249 1.902-.798.475-.548.667-1.286.519-1.996-.207-.995.256-2.01 1.145-2.505.633-.354 1.065-.982 1.169-1.7s-.135-1.443-.643-1.96zm-12.584 5.43l-4.5-4.364 1.857-1.857 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.642z"
                          ></path>
                        </svg>
                      </span>
                      <span class="text-medium" style="color: #0a5685"
                        >Manage Subscription</span
                      >
                    </b-dropdown-item-button>
                  </router-link>
                  <router-link
                    :to="{ name: 'organization' }"
                    class="no-underline"
                  >
                    <b-dropdown-item-button class="header">
                      <span class="pr-2" style="color: #0a5685">
                        <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="#72809D"
                  viewBox="0 0 30 30"
                >
                  <path
                    d="M14.078 4.232l-12.64 12.639-1.438 7.129 7.127-1.438 12.641-12.64-5.69-5.69zm-10.369 14.893l-.85-.85 11.141-11.125.849.849-11.14 11.126zm2.008 2.008l-.85-.85 11.141-11.125.85.85-11.141 11.125zm18.283-15.444l-2.816 2.818-5.691-5.691 2.816-2.816 5.691 5.689z"
                  ></path>
                </svg>
                      </span>
                      <span class="text-medium" style="color: #0a5685"
                        >Switch Organization</span
                      >
                    </b-dropdown-item-button>
                  </router-link>
                  <b-dropdown-item-button @click="logoutUser" class="header">
                    <span class="pr-2" style="color: #0a5685">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 30 30"
                        fill="#0a5685"
                        xmlns="http://www.w3.org/2000/svg"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                      >
                        <path
                          d="M24 22h-20v-7h2v5h16v-16h-16v5h-2v-7h20v20zm-13-11v-4l6 5-6 5v-4h-11v-2h11z"
                        ></path>
                      </svg>
                    </span>
                    <span class="text-medium" style="color: #0a5685"
                      >Logout</span
                    >
                  </b-dropdown-item-button>
                  <!-- <b-dropdown-item-button class="header">
                    <i
                      class="zmdi zmdi-settings pr-2 text-opacity"
                      style="font-size:15px; margin-top:3px"
                    ></i>Settings
                  </b-dropdown-item-button>
                  <b-dropdown-item-button @click="logoutUser" class="header">
                    <i
                      class="zmdi zmdi-sign-in pr-2 text-opacity"
                      style="font-size:15px; margin-top:3px"
                    ></i> Logout
                  </b-dropdown-item-button>-->
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import handleError from "@/helpers/error";
import { updatePending } from "@/helpers/axiosIntercept";
import SubscribeNotifier from "@/components/Navbar/SubscriptionNotifier";
import {optional} from "@/helpers/random"

export default {
  data() {
    return {
      showDropMenu: false,
    };
  },
  props: ["disabled"],
  components: { SubscribeNotifier },
  methods: {
    optional,
    checkSubLink(path) {
      // console.log(this.$route.name.match(/projects/g))
      const paths = Array.isArray(path) ? path : [path];
      return paths.some((path) => {
        return this.$route.path.includes(path);
      });
    },
    logoutUser() {
      this.$auth
        .logout({
          makeRequest: true,
          params: {}, // data: {} in axios
          redirect: false,
          // etc...
        })
        .then(() => {
          //delete token
          window.localStorage.clear();
          this.$router.push({ name: "Login" });
        })
        .catch((e) => {
          handleError(this, e, "Logout failed");
        })
        .finally(() => {
          updatePending(this.$logoutUrl);
        });
    },
    toggleDropDown() {
      this.showDropMenu = !this.showDropMenu;
       if(this.$refs["dropmenu"]) {
         this.showDropMenu 
        ? this.$refs["dropmenu"].hide()
        : this.$refs["dropmenu"].show();
       }
    },
  },
  computed: {
    organization() {
      return this.$store.getters['global/selected_org'];
    },
  },
  mounted() {
    // this.organization();
    if (this.$auth.user().password_must_change == 1) {
      window.localStorage.setItem(
        "error_message",
        "You must change your password immediately to proceed"
      );
      this.$router.push({
        name: "reset-password",
        query: { redirect: window.location.href },
      });
    }
  },
};
</script>
